import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDifferenceIgnored: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="difference-ignored"><path fillRule="evenodd" clipRule="evenodd" d="M17.25 3C19.3211 3 21 4.67893 21 6.75V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V6.75C3 4.67893 4.67893 3 6.75 3H17.25ZM15.7803 8.21973C15.4874 7.92683 15.0126 7.92683 14.7197 8.21973L8.21973 14.7197C7.92683 15.0126 7.92683 15.4874 8.21973 15.7803C8.51262 16.0732 8.98738 16.0732 9.28027 15.7803L15.7803 9.28027C16.0732 8.98738 16.0732 8.51262 15.7803 8.21973Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDifferenceIgnored;
